export enum VrsCallType {
  REGULAR_CALL = 'regularCall',
  FAST_CALL = 'fastCall',
  EMERGENCY_CALL = 'emergencyCall',
  EMERGENCY_CALLBACK = 'emergencyCallback',
}
